module.exports = __webpack_public_path__ + "static/media/claimStats.78bd7671.png";